import axios, { AxiosResponse } from 'axios';
import { mutate } from 'swr';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { IRequestData } from './interfaces';

const path = `${SERVICES.LENDER}/lenders`;

export const lenderAlreadyExists = 'Lender already exists';

export const requestUpdateMeridianLender = (meridianLender: IRequestData, lenderId: string) => {
    const url = `${path}/${lenderId}/meridian-configuration`;
    return mutate(path, async () => {
        try {
            const response: AxiosResponse<string> = await axios.patch(url, meridianLender);
            if (meridianLender.isNewConfiguration) {
                Notistack.successMessage('Meridian Lender - Created Successfully');
            } else {
                Notistack.successMessage('Meridian Lender - Updated Successfully');
            }
            return response.data;
        } catch (err) {
            const error = getError(err);
            if (!error.includes(lenderAlreadyExists)) {
                Notistack.generalError(error);
            }
            return error;
        }
    });
};

export const requestDeleteMeridianLender = (lenderId: string) => {
    return mutate(path, async () => {
        try {
            await axios.delete(`${path}/${lenderId}/meridian-configuration`);
            Notistack.successMessage('Meridian Lender - Deleted Successfully');
        } catch (err) {
            Notistack.generalError(getError(err));
        }
    });
};